<template lang="pug">
div
  div
    em-loading(:is-full-page="false" :active="isLoading")
    .is-flex.is-align-items-center
      .mr-3
        span.icon
          i.mdi.mdi-bell-outline.mdi-24px.has-text-primary(v-if="isSubscribed")
          i.mdi.mdi-bell-off-outline.mdi-24px(v-else)
      div.is-flex-grow-1
        h3.title.is-5 {{ $t('settings.push_notifications.title') }}
        p.subtitle.is-6 {{ $t('settings.push_notifications.subtitle') }}
      div
        div(v-if="isPushSupported && permissionStatus !== 'denied'")
          b-switch(v-model="pushEnabled" @input="togglePushNotifications")
            //span {{ pushEnabled ? $t('settings.push_notifications.enabled') : $t('settings.push_notifications.disabled') }}
   
    .has-text-centered.my-4(v-if="!isPushSupported")
      p.has-text-danger {{ $t('settings.push_notifications.not_supported') }}
    
    .has-text-centered.my-4(v-else-if="permissionStatus === 'denied'")
      p.has-text-danger {{ $t('settings.push_notifications.permission_denied') }}
      p.is-size-7.has-text-grey {{ $t('settings.push_notifications.permission_help') }}
      //- .has-text-centered.my-4(v-else)
      //-   b-switch(v-model="pushEnabled" @input="togglePushNotifications")
      //-     span {{ pushEnabled ? $t('settings.push_notifications.enabled') : $t('settings.push_notifications.disabled') }}
      
      //.mt-2(v-if="isLoading")
        
      
    .notification.is-danger.is-light.mt-3(v-if="error")
      p {{ error }}
      
    .mt-4.is-size-7.has-text-grey.has-text-right
      a.has-text-grey(@click="showDebug = !showDebug") {{ showDebug ? 'Hide Debug Info' : 'Show Debug Info' }}
  
  push-notifications-debug(v-if="showDebug")
</template>

<script>
import {
  isPushSupported,
  checkPushSubscription,
  subscribeToPushNotifications,
  unsubscribeFromPushNotifications,
  getNotificationPermission
} from '../../utils/pushNotifications'
import PushNotificationsDebug from './PushNotificationsDebug.vue'

export default {
  components: {
    PushNotificationsDebug
  },
  data() {
    return {
      isSupported: false,
      isSubscribed: false,
      pushEnabled: false,
      permissionStatus: 'default',
      isLoading: false,
      error: null,
      showDebug: false
    }
  },
  computed: {
    isPushSupported() {
      return this.isSupported
    }
  },
  async mounted() {
    this.isSupported = isPushSupported()

    if (this.isSupported) {
      await this.checkSubscriptionStatus()
    }
  },
  methods: {
    async checkSubscriptionStatus() {
      try {
        this.isLoading = true
        this.error = null

        // Check permission status
        const permissionResult = getNotificationPermission()
        this.permissionStatus = permissionResult.permission

        // If permission is denied, we can't proceed
        if (this.permissionStatus === 'denied') {
          this.pushEnabled = false
          this.isSubscribed = false
          this.isLoading = false
          return
        }

        // Check subscription status

        const subscriptionStatus = await checkPushSubscription()
        this.isSubscribed = subscriptionStatus.subscribed
        this.pushEnabled = subscriptionStatus.subscribed
      } catch (error) {
        console.error('Error checking subscription status:', error)
        this.error = this.$t('settings.push_notifications.check_error')
      } finally {
        this.isLoading = false
      }
    },
    async togglePushNotifications(value) {
      try {
        this.isLoading = true
        this.error = null

        if (value) {
          // Subscribe
          await subscribeToPushNotifications()
          this.isSubscribed = true
          this.$buefy.toast.open({
            message: this.$t('settings.push_notifications.subscribed_success'),
            type: 'is-success'
          })
        } else {
          // Unsubscribe
          const result = await unsubscribeFromPushNotifications()
          if (result.success) {
            this.isSubscribed = false
            this.$buefy.toast.open({
              message: this.$t('settings.push_notifications.unsubscribed_success'),
              type: 'is-success'
            })
          } else {
            throw new Error(result.error || 'Failed to unsubscribe')
          }
        }
      } catch (error) {
        console.error('Error toggling push notifications:', error)
        this.error = error.message
        this.pushEnabled = this.isSubscribed // Revert toggle
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
